<template>
  <div v-if="copied" class="text-success">
    <span class="fas fa-check"></span>
    <small class=""> Copiado!</small>
  </div>
  <button v-else class="btn btn-sm btn-white lift border-0" @click="copy">
    <slot v-if="$slots.icon" name="icon"></slot>
    <PhIcons v-else name="share" :size="20" />
  </button>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = defineProps<{ string?: string }>();
const copied = ref(false);

function copy() {
  if (copied.value) return;
  copied.value = true;
  setTimeout(() => (copied.value = false), 2000);
  navigator.clipboard.writeText(props.string ?? "");
}
</script>
